import * as turf from '@turf/turf';
import { Feature, Polygon, LineString } from '@turf/turf';

export class LineIntersecter {
    isAnyPortionOfLineWithinPolygon = ({ line, polygon }: { line: Feature<LineString>; polygon: Feature<Polygon> }): boolean => {
        // the primary method for checking this is to use turf.lineIntersect
        // which will tell us what points of the line intersect our polygon
        // this will usually result in 2 points for a mission radius
        // but if the line ends in the radius, then we'll get one point
        // and if the line is entirely contained in the radius, then we'll get zero
        // points which is ambiguous with if the line is entirely outside our radius
        // we can work around that by checking to see if a point is inside our polygon
        // and we do that first for performance optimization
        const aPoint = turf.point(line.geometry.coordinates[0]);

        const containsAPoint = turf.booleanContains(polygon, aPoint);

        if (containsAPoint){
            return true;
        }

        const points = turf.lineIntersect(line, polygon);
        return points.features.length > 0;
    }
}
